export const hexWithOpacity = (hexColor, alpha) => `rgba(
  ${parseInt(hexColor.slice(1, 3), 16)},
  ${parseInt(hexColor.slice(3, 5), 16)},
  ${parseInt(hexColor.slice(5, 7), 16)},
  ${alpha})`;
